import { createSelector } from 'reselect';
import { initialState } from './reducer';
import { INVOICES_DOMAIN } from './constants';

const selectInvoicesDomain = state => state[INVOICES_DOMAIN] || initialState;

export const selectInvoices = () =>
  createSelector(
    selectInvoicesDomain,
    d => d.invoices,
  );

export const selectProductInvoices = () =>
  createSelector(
    selectInvoicesDomain,
    d => d.productInvoices,
  );

export const selectCompanyInvoices = () =>
  createSelector(
    selectInvoicesDomain,
    d => d.companyInvoices,
  );

export const selectVehicleInvoices = () =>
  createSelector(
    selectInvoicesDomain,
    d => d.vehicleInvoices,
  );

export const selectInvoice = () =>
  createSelector(
    selectInvoicesDomain,
    d => d.invoice,
  );

export const selectInvoiceBare = () =>
  createSelector(
    selectInvoicesDomain,
    d => d.invoiceBare,
  );

export const selectInvoiceById = id =>
  createSelector(
    selectInvoicesDomain,
    d => d.invoicesById?.[id],
  );

export const selectNewInvoiceValue = name =>
  createSelector(
    selectInvoicesDomain,
    d => d.newInvoice[name],
  );

export const selectNewInvoice = () =>
  createSelector(
    selectInvoicesDomain,
    d => d.newInvoice,
  );

export const selectCompany = () =>
  createSelector(
    selectInvoicesDomain,
    d => d.company,
  );

export const selectStatuses = () =>
  createSelector(
    selectInvoicesDomain,
    d => d.statuses,
  );

export const selectPaginator = () =>
  createSelector(
    selectInvoicesDomain,
    d => d.paginator,
  );

export const selectItemsCount = () =>
  createSelector(
    selectInvoicesDomain,
    d => d.itemsCount,
  );

export const selectInvoiceFilter = () =>
  createSelector(
    selectInvoicesDomain,
    d => d.filter,
  );

export const selectVatCodes = () =>
  createSelector(
    selectInvoicesDomain,
    d => d.vatCodes,
  );

export const selectExactAuthStatus = () =>
  createSelector(
    selectInvoicesDomain,
    d => d.exactAuthStatus,
  );

export const selectExactAuthInitialLink = () =>
  createSelector(
    selectInvoicesDomain,
    d => d.exactAuthInitialLink,
  );

export const selectCompanyTransportLocations = () =>
  createSelector(
    selectInvoicesDomain,
    d => d.companyTransportLocations,
  );

export const selectAutotelexBPM = () =>
  createSelector(
    selectInvoicesDomain,
    d => d.fetchedBPM,
  );

export const selectLedgers = () =>
  createSelector(
    selectInvoicesDomain,
    d => d.ledgers,
  );

export const selectWebhooksList = () =>
  createSelector(
    selectInvoicesDomain,
    d => d.webhooks,
  );

export const selectLatestProductInvoice = () =>
  createSelector(
    selectInvoicesDomain,
    d => d.latestProductInvoiceId,
  );
